import IconSvg from './assets/icons/48/error.svg';
import { FC } from 'react';
const Icon: FC = () => <img alt="error" src={IconSvg} width="48px" height="48px" />;

export default Icon;
